<template>
    <header>
        <div class="topnav" id="topnav">
            <div class="container-fluid">
                <div class="row nav-grad">
                    <div class="backoverlay"></div>
                    <div class="col-xl-2 col-lg-2 col-6 site-logo">
                        <router-link :to="$i18nRoute({ name: 'home'})">
                            <img src="../../assets/img/zespri-nav-logo.png" alt="logo" class="img-fluid" id="nav_menu-101">
                        </router-link></div>
                    <div class="col-xl-9 col-lg-10 col-6 main-nav">
                      <ul id="mainmenu" class="main-nav lan_benl" :class="{'--active': showMenu}">
                          <li class="hasSubMenu">
                              <a :href="$t('nav.kiwi.url')" class="main tgroup">{{ $t('nav.kiwi.title') }}</a>
                              <div class="submenu" id="submenu"></div>
                          </li>
                          <li class="hasSubMenu">
                              <a :href="$t('nav.voeding.url')" class="main tgroup">{{ $t('nav.voeding.title') }}</a>
                              <div class="submenu" id="submenu"></div>
                          </li>
                          <li class="hasSubMenu">
                              <a :href="$t('nav.zespri.url')" class="main tgroup">{{ $t('nav.zespri.title') }}</a>
                              <div class="submenu" id="submenu"></div>
                          </li>
                          <li class="hasSubMenu">
                              <a :href="$t('nav.promo.url')" class="main tgroup">{{ $t('nav.promo.title') }}</a>
                              <div class="submenu" id="submenu">
                                      <a :href="$t('nav.promo.sub1.url')" class="">{{ $t('nav.promo.sub1.title') }}</a>
                                      <a :href="$t('nav.promo.sub2.url')" class="">{{ $t('nav.promo.sub2.title') }}</a>
                              </div>
                          </li>
                          <li class="hasSubMenu">
                              <a :href="$t('nav.vitaliteit.url')" class="main tgroup">{{ $t('nav.vitaliteit.title') }}</a>
                              <div class="submenu" id="submenu"></div>
                          </li>
                      </ul>
                    </div>
                </div>
            </div>
            <a class="onlymobile icon togglemenu" id="togglemenu" v-on:click="showMenu=!showMenu"></a>
        </div>
    </header>
</template>

<script>
import { Trans } from '@/plugins/Translation'
import ClickOutside from 'vue-click-outside'
export default {
  name: "Navbar",
  directives: {
    ClickOutside
  },
  data() {
    return {
      showMenu: false
    }
  },
  computed: {
    supportedLanguages () {
      return Trans.supportedLanguages
    },
    currentLanguage () {
      return Trans.currentLanguage
    }
  },
  methods: {
    changeLanguage (lang) {
      const to = this.$router.resolve({ params: { lang } })
      return Trans.changeLanguage(lang).then(() => {
        this.$router.push(to.location)
        location.reload();
      })
    },
    isCurrentLanguage (lang) {
      return lang === this.currentLanguage
    },
    hideMenu () {
      this.showMenu = false;
    },
    toggleMenu () {
      this.showMenu = !this.showMenu;
    }
  }
}
</script>
